<template>
  <el-dialog v-show="dialogVisible" :visible.sync="dialogVisibleShow" width="680px" top="5vh">
    <div slot="title" class="dialog-title">
      <h1 class="title">{{dialogData.type==='_PAYMENT'? '工资打款示例': '发票申请示例'}}</h1>
    </div>
    <div class="content">
      <el-carousel height="427px" :autoplay="false" @change="carouselOnChange">
        <el-carousel-item v-for="(item) in carouselList" :key="item.imgUrl">
          <img style="width:100%; height:100%" :src="item.imgUrl" alt="">
        </el-carousel-item>
      </el-carousel>
      <p class="p-text"><span class="span-text">第{{indexCurser + 1}}步、</span>{{carouselList[indexCurser].step}}</p>
    </div>
  </el-dialog>
</template>
<script>
import { dialogMixin } from 'src/mixin/index'
export default {
  mixins: [dialogMixin],
  props: {
    dialogData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      indexCurser: 0,
      parymentList: [
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_PAYMENT_step11.png',
          step: '点击“发放工资”，创建打款项目后保存'
        },
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_PAYMENT_step12.png',
          step: '添加打款项目成功后，选择表格批量导入或单个添加收款人信息'
        },
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_PAYMENT_step13.png',
          step: '导入收款人信息后，确认打款金额，点击“立即支付”'
        },
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_PAYMENT_step14.png',
          step: '选择支付方式后，进行支付'
        },
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_PAYMENT_step15.png',
          step: '打款完毕。点击“详情”资查看工资发放状态'
        }
      ],
      invoiceList: [
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_INVOICE_step1.png',
          step: '点击“发票申请”，填写发票信息后保存.'
        },
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_INVOICE_step2.png',
          step: '点击“地址管理”，添加收件信息后保存'
        },
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_INVOICE_step3.png',
          step: '点击“申请发票”，选择开票项目，确认金额后点击“下一步”'
        },
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_INVOICE_step4.png',
          step: '确认发票信息和收件地址后点击“立即支付”'
        },
        {
          imgUrl: 'https://qiniu-app.qtshe.com/qtbao-pc/20180807/_INVOICE_step5.png',
          step: '选择支付方式后，完成支付'
        }
      ]
    }
  },
  computed: {
    carouselList() {
      //this.indexCurser = 0
      if (this.dialogData.type === '_PAYMENT') {
        return this.parymentList
      }
      if (this.dialogData.type === '_INVOICE') {
        return this.invoiceList
      }
      return [{}]
    }
  },
  methods: {
    btnCloseClick() {
      this.$emit('update:dialogVisible', false)
    },
    carouselOnChange(val) {
      this.indexCurser = val
    }
  }
}
</script>
<style lang="less" scoped>
.dialog-title{
  .title{
    position: relative;
    top: 0;
    left: 0;
    font-size: 20px;
    &::after{
      display: block;
      content: '';
      width: 24px;
      height: 5px;
      margin-top: 10px;
      background: #00BBEE;
    }
  }
}
.content{
  margin-top: -30px;
  .p-text{
    margin-top: 16px;
    font-size: 12pt;
    color: #3C3C3C;
    text-align: center;
    .span-text{
      font-weight: 600;
    }
  }
}
.el-carousel__item h3 {
	color: #475669;
	font-size: 14px;
	opacity: 0.75;
	line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
	background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
	background-color: #d3dce6;
}
</style>
/**
* @desc: 轮播·流程图
* @author: zengtiansheng
*/


// WEBPACK FOOTER //
// src/views/home/modules/carousel.vue